import { SLAViewDto } from '@issuemanager/api-client';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export type UseSLAHelperTextParams = {
  SLAs?: SLAViewDto[];
  severity?: string;
  slaEnabled?: boolean;
  issueSeverity?: string | null;
};

export function useSLAHelperText({
  SLAs,
  severity,
  slaEnabled,
  issueSeverity,
}: UseSLAHelperTextParams): string | undefined {
  const { t } = useTranslation(['issue']);

  return useMemo(() => {
    if (!severity || !SLAs?.length) return undefined;

    const isSeverityChanging = severity !== issueSeverity;

    if (!slaEnabled && !isSeverityChanging) {
      return undefined;
    }

    const selectedSLA = SLAs.find((sla) => sla.severity === severity);
    if (!selectedSLA) return undefined;
    return t('issue:form.helperText.slaApplied', {
      maxDueDate: selectedSLA.maxDueDate,
    });
  }, [SLAs, severity, slaEnabled, issueSeverity, t]);
}
